import { Result } from "core/utils";
import { useEffect, useState } from "react";
export var State;
(function (State) {
    State[State["NoSearch"] = 0] = "NoSearch";
    State[State["NoResults"] = 1] = "NoResults";
    State[State["Results"] = 2] = "Results";
})(State || (State = {}));
var useSearchState = function (result, showSearch) {
    var _a = useState(State.NoSearch), state = _a[0], setState = _a[1];
    useEffect(function () {
        // reset search when search is closed
        if (!showSearch) {
            setState(State.NoSearch);
            return;
        }
        if (result === null) {
            setState(State.NoSearch);
            return;
        }
        if (Result.isFail(result)) {
            setState(State.NoResults);
            return;
        }
        if (Result.isSuccess(result) && result.value.length === 0) {
            setState(State.NoResults);
            return;
        }
        setState(State.Results);
    }, [result]);
    return [state, setState];
};
export default useSearchState;
